// extracted by mini-css-extract-plugin
export default {"container":"services_container__gi6cG","item":"services_item__k3Anv"};